var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.event.type !== 'notCreated' ? _c('div', {
    staticClass: "podpis-event-banner"
  }, [_c('div', {
    staticClass: "div-block-142"
  }, [_c('img', {
    staticClass: "image-10",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f37_avatar%20cropped.png",
      "loading": "lazy",
      "width": "40",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "div-block-143"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.translateEventType(_vm.event.type)) + " "), _c('span', {
    staticClass: "place"
  }, [_vm._v(_vm._s(_vm.getAddressModified(_vm.event.meta.addressMeta)))])]), _c('div', {
    staticClass: "term"
  }, [_vm._v(_vm._s(_vm.transformDate(_vm.event.start)))])])]), _c('div', [_c('button', {
    staticClass: "w-button",
    on: {
      "click": _vm.eventExtendedView
    }
  }, [_vm._v(" Navrhnúť nový ")])])]) : _c('div', {
    staticClass: "podpis-event-banner"
  }, [_vm._m(0), _c('button', {
    staticClass: "w-button",
    on: {
      "click": _vm.openCreateEventDialog
    }
  }, [_vm._v("Vytvoriť")])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "div-block-142"
  }, [_c('img', {
    staticClass: "image-10",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f39_calendar%20icon.png",
      "loading": "lazy",
      "width": "40",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "div-block-143"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v(" Zatiaľ nie je dohodnutý podpis žiadostí ")])])]);

}]

export { render, staticRenderFns }